import { Modal, ModalBody, ModalHeader, Button, Collapse } from 'reactstrap';
import { useState } from "react";
import { useFormikContext } from "formik";
import blue_trash from 'assets/images/svgs/blue-trash-icon.svg';

const JobScreeningQuestionsEditModal = (props) => {
    const { modal, setModal } = props;
    const { values, setFieldValue } = useFormikContext();
    const [openCustomQuestion, setOpenCustomQuestion] = useState(false);
    const [customQuestion, setCustomQuestion] = useState({ question: '', renderType: 'NUMBER', options: [] });

    const [finalSubmissions, setFinalSubmissions] = useState(values?.screeningQuestions);

    const [suggestedQuestions, setSuggestedQuestions] = useState([
        {
            id: 1,
            question: "How many years of Experience do you have in OPD?",
            renderType: 'NUMBER',
            options: []
        },
        {
            id: 2,
            question: "Do you like to work shift basis?",
            renderType: 'SELECT',
            options: ["YES", "NO"]
        },
        {
            id: 3,
            question: "Are you available for ICU?",
            renderType: 'TEXT',
            options: []
        }
    ]);

    const addSelectedQuestion = (selectedQuestion) => {
        const newQuestion = { ...selectedQuestion };
        if (selectedQuestion.renderType === 'SELECT' && !selectedQuestion.options.length) {
            newQuestion.options = ["YES", "NO"];
        }

        // Ensure screeningQuestions is an array
        const currentQuestions = finalSubmissions ?? [];
        const newQuestions = [...currentQuestions, newQuestion];
        setFinalSubmissions(newQuestions);
    }

    const removeQuestion = (indexToRemove) => {
        const newQuestions = finalSubmissions.filter((_, index) => index !== indexToRemove);
        setFinalSubmissions(newQuestions);
    }

    const isQuestionSelected = (question) => {
        return (finalSubmissions && finalSubmissions.some(selectedQuestion => selectedQuestion.question === question.question));
    }

    const handleCustomQuestionChange = (e) => {
        const { name, value } = e.target;
        setCustomQuestion({
            ...customQuestion,
            [name]: value
        });
    }

    const handleSaveCustomQuestion = () => {
        const newCustomQuestion = { ...customQuestion, id: Date.now() }; // Assign a unique id
        if (newCustomQuestion.renderType === 'SELECT') {
            newCustomQuestion.options = ["YES", "NO"];
        }
        addSelectedQuestion(newCustomQuestion);
        setOpenCustomQuestion(false);
        setCustomQuestion({ question: '', renderType: 'NUMBER', options: [] });
    }

    const handleCancelCustomQuestion = () => {
        setOpenCustomQuestion(false);
        setCustomQuestion({ question: '', renderType: 'NUMBER', options: [] });
    }

    const getFilteredSuggestedQuestions = () => {
        return suggestedQuestions.filter(question => !isQuestionSelected(question));
    }

    const handleSubmit = () => {
        setFieldValue('screeningQuestions', finalSubmissions);
        setModal(false);
    }

    const filteredSuggestedQuestions = getFilteredSuggestedQuestions();

    return (
        <Modal isOpen={modal} toggle={() => setModal(!modal)} className="nex-model-v2 modal-dialog-scrollable modal-dialog-centered">
            <ModalHeader toggle={() => setModal(!modal)}>Edit Apply mode</ModalHeader>
            <ModalBody>
                <>
                    <div className="nex-job-form-right-sec">
                        <div className="nex-flex wrap custom">
                            <h2 className='nex-text-xl-small'>Screening Question</h2>
                            <Button className='btn nex-button-outline nex-own-question' onClick={() => setOpenCustomQuestion(!openCustomQuestion)}>+ Add your own Question</Button>
                        </div>

                        <div className="form-group mb-4">
                            <Collapse isOpen={openCustomQuestion} className="mt-3">
                                <div className="card nex-collapse-card v2">
                                    <div className="card-body">
                                        <div className="card-group">
                                            <label>Type your own Question</label>
                                            <div className="from-group form-inline-field">
                                                <input
                                                    type="text"
                                                    name="question"
                                                    value={customQuestion.question}
                                                    onChange={handleCustomQuestionChange}
                                                    className='form-control'
                                                />
                                                <Button className='btn nex-btn-transparent' onClick={handleCancelCustomQuestion}>
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="16.2266" cy="16" r="15.75" fill="#FFEAEF" />
                                                        <path d="M11.3984 13.7734L12.2586 20.1323C12.426 21.3702 12.5097 21.9892 12.9337 22.3597C13.3577 22.7302 13.9823 22.7302 15.2315 22.7302H18.4692C19.7184 22.7302 20.343 22.7302 20.767 22.3597C21.191 21.9892 21.2747 21.3702 21.4421 20.1323L22.3023 13.7734" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M14.5156 11.0475V11.0475C14.5156 10.2672 14.5156 9.87708 14.6572 9.57473C14.8061 9.25693 15.0616 9.00138 15.3794 8.85254C15.6818 8.71094 16.0719 8.71094 16.8522 8.71094V8.71094C17.6324 8.71094 18.0226 8.71094 18.3249 8.85254C18.6427 9.00138 18.8983 9.25693 19.0471 9.57473C19.1887 9.87708 19.1887 10.2672 19.1887 11.0475V11.0475" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M22.3023 11.0547L11.3984 11.0547" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M14.8906 14.1719L15.28 20.0132" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M18.7957 14.1719L18.4062 20.0132" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </Button>
                                            </div>
                                            <label htmlFor="">Answer Type</label>
                                            <div className="from-group form-inline-field mb-0">
                                                <select
                                                    name="renderType"
                                                    value={customQuestion.renderType}
                                                    onChange={handleCustomQuestionChange}
                                                    className='form-control nex-max-w-300'
                                                >
                                                    <option value="NUMBER">Number</option>
                                                    <option value="SELECT">Yes/No</option>
                                                    <option value="TEXT">Text</option>
                                                </select>
                                                <Button className='btn nex-button-outline' onClick={handleSaveCustomQuestion}>Save</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                        {finalSubmissions && finalSubmissions.length > 0 &&
                            <div className="nex-suggest-question-sec">
                                <h2 className='nex-text-lg text-black'>Selected Question</h2>
                                {finalSubmissions && finalSubmissions.map((e, index) => (
                                    <div className="card bg-white mb-4" key={index}>
                                        <div className="card-body ">
                                            <h3 className="card-title">{e.question}</h3>
                                            <div className="nex-text" htmlFor="">{"Answer Type"}{": "}<span className="nex-val">{e.renderType}</span></div>

                                            {/* <Button className="nex-btn-transparent" onClick={() => removeQuestion(index)}><img src={blue_trash} alt="" /></Button> */}
                                            <Button className="nex-btn-transparent" onClick={() => removeQuestion(index)}>
                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="16.2266" cy="16" r="15.75" fill="#FFEAEF" />
                                                    <path d="M11.3984 13.7734L12.2586 20.1323C12.426 21.3702 12.5097 21.9892 12.9337 22.3597C13.3577 22.7302 13.9823 22.7302 15.2315 22.7302H18.4692C19.7184 22.7302 20.343 22.7302 20.767 22.3597C21.191 21.9892 21.2747 21.3702 21.4421 20.1323L22.3023 13.7734" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M14.5156 11.0475V11.0475C14.5156 10.2672 14.5156 9.87708 14.6572 9.57473C14.8061 9.25693 15.0616 9.00138 15.3794 8.85254C15.6818 8.71094 16.0719 8.71094 16.8522 8.71094V8.71094C17.6324 8.71094 18.0226 8.71094 18.3249 8.85254C18.6427 9.00138 18.8983 9.25693 19.0471 9.57473C19.1887 9.87708 19.1887 10.2672 19.1887 11.0475V11.0475" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M22.3023 11.0547L11.3984 11.0547" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M14.8906 14.1719L15.28 20.0132" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M18.7957 14.1719L18.4062 20.0132" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        }

                        {filteredSuggestedQuestions.length > 0 && (
                            <>
                                <h2 className='nex-text-lg bold text-black'>Suggested Questions</h2>
                                <div className="row">
                                    <div className="col-lg-12">
                                        {filteredSuggestedQuestions.map((e, index) => (
                                            <Button
                                                key={index}
                                                color="primary"
                                                className='nex-light-collapse-btn'
                                                onClick={() => addSelectedQuestion(e)}
                                            >
                                                {e.question}
                                            </Button>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </>
                <div className="form-group nex-action-flex">
                    <Button
                        id="nex-pa-about-submit-btn"
                        className="nex-btn-primary mr-2"
                        color="primary"
                        onClick={handleSubmit}
                    >
                        Save
                    </Button>
                    <Button
                        id="nex-pa-about-cancel-btn"
                        onClick={() => setModal(false)}
                        className="nex-btn-primary-outline"
                        color="primary"
                    >
                        Cancel
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default JobScreeningQuestionsEditModal;
